export default __webpack_public_path__ + "static/media/wedding_livestream.45d9fdf1.jpg";